import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useFormik } from 'formik';
import DialogPanel from '../dialog-panel/dialog-panel';
import DialogPanelBody from '../dialog-panel/dialog-panel-body/dialog-panel-body';
import './request-approval.scss';
import DialogPanelFooter from '../dialog-panel/dialog-panel-footer/dialog-panel-footer';
import Button from '../button/button';
import CustomEditor from '../text-editor/custome-texteditor';
import ForwarderUploadDocument from '../create-booking/forwarder-upload-document';
import TextBox from '../text-box/text-box';
import { APPROVE_QUOTATION_REQUEST } from '../../graphQL/bookingDetailsPage';

function RequestQuotationApproval({
  bookingId,
  quotationId,
  amount,
  currency,
  // requestSendForapprovaldata,
  closeDialog,
  refetchBookingDetails,
}) {
  const [t] = useTranslation('managebooking');
  const [t2] = useTranslation('managecustoms');

  const [attachments, setAttachments] = useState([]);
  const [apiCallPending, setApiCallPending] = useState(false);

  const [handleApproveQuotation] = useMutation(APPROVE_QUOTATION_REQUEST);

  // useEffect(() => {
  //   setAttachments(requestSendForapprovaldata?.attachments);
  // }, [requestSendForapprovaldata]);

  const formik = useFormik({
    initialValues: {
      amount: amount ? `${amount} ${currency}` : '--',
      comments: '',
      document: [],
    },
    onSubmit: (values) => {
      setApiCallPending(true);
      const payload = {
        bookingId,
        quotationId,
        documentLink: values?.document,
        reason: values?.comments,
      };
      handleApproveQuotation({
        variables: {
          input: payload,
        },
        onCompleted: (data) => {
          toast.success(data?.UpdateQuotation?.message);
          closeDialog();
          refetchBookingDetails();
        },
      });
    },
  });

  const handleUploadDocument = (id, array) => {
    setAttachments(array);
    formik.setFieldValue('document', array);
  };
  const getPlainText = (htmlString) => {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlString;
    return tempDiv.textContent || tempDiv.innerText || '';
  };

  return (
    <div className="additional-expenses">
      <DialogPanel
        title={t2('quoteApprovalFlow.requestApprovalTitle')}
        large="booking-details-title"
        className="request-expenses-dialog"
      >
        <form onSubmit={formik.handleSubmit}>
          <DialogPanelBody>
            <p className="mt-0 fw-600 text-navy-primary">
              {t2('quoteApprovalFlow.requestApprovalHeading')}
            </p>
            <TextBox
              id="amount"
              name="amount"
              label={t2('quoteApprovalFlow.amount')}
              className="mb-25"
              value={formik.values.amount}
              disabled
            />

            <CustomEditor
              disabledSend
              charLimit="250"
              disabledAttach
              disableFontSize
              disableUnderline
              name="comments"
              type="text"
              rows="2"
              className="h-100 quatation"
              label={t2(
                'managecustomsscreen.requestadditonalexpenses.pleaseprovideabriefexplanation'
              )}
              placeholder={t2(
                'managecustomsscreen.requestadditonalexpenses.briefexplanation'
              )}
              getEditorValue={(e) => {
                const plainText = getPlainText(e);
                formik.setFieldValue('comments', plainText);
              }}
              movetoBottom
              disableAlignment
              required
            />

            <ForwarderUploadDocument
              id="doc"
              handleUploadDocument={handleUploadDocument}
              label={t2('quoteApprovalFlow.uploadSupportDocs')}
              uploadedAttachement={attachments}
              t={t}
              errorMessage={formik.touched.document && formik.errors.document}
              isRequired={false}
            />
          </DialogPanelBody>
          <DialogPanelFooter>
            <>
              <Button
                label={t2(
                  'managecustomsscreen.requestadditonalexpenses.cancel'
                )}
                color="cancel"
                onClick={() => {
                  formik.resetForm();
                  closeDialog();
                }}
                disabled={apiCallPending}
              />
              <Button
                type="submit"
                label={
                  apiCallPending
                    ? t2('quoteApprovalFlow.wait')
                    : t2('managecustomsscreen.requestadditonalexpenses.submit')
                }
                color="submit"
                disabled={apiCallPending || !formik?.values?.comments?.trim()}
              />
            </>
          </DialogPanelFooter>
        </form>
      </DialogPanel>
    </div>
  );
}
RequestQuotationApproval.propTypes = {
  bookingId: PropTypes.string.isRequired,
  quotationId: PropTypes.string.isRequired,
  amount: PropTypes.string.isRequired,
  currency: PropTypes.string.isRequired,
  closeDialog: PropTypes.func.isRequired,
  refetchBookingDetails: PropTypes.func.isRequired,
};

export default RequestQuotationApproval;
